import { assign } from 'xstate';

import {
  AddonsConfigurationContext,
  UpdateAllocationsListEvent,
  Error,
} from './types';

export const updateAllocationsList = assign({
  allocations: (
    context: AddonsConfigurationContext,
    event: UpdateAllocationsListEvent
  ) => {
    const {
      allocation,
      allocation: { id },
    } = event;
    const index = context.allocations.findIndex((a) => a.id === id);
    if (index > -1) {
      return context.allocations.map((a) => (a.id === id ? allocation : a));
    }
    return [...context.allocations, allocation];
  },
});

export const setError = assign(
  (context: AddonsConfigurationContext, event: any) => {
    return {
      ...context,
      error: event.data as Error,
    };
  }
);
